import { render, staticRenderFns } from "./verifyAddress.vue?vue&type=template&id=b3ff8dbc&"
import script from "./verifyAddress.vue?vue&type=script&lang=js&"
export * from "./verifyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports